import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { AvatarComponent } from '@components/avatar/avatar.component';
import { AccountRole } from '@core/models/account/account-role';
import { Company } from '@core/models/common/company';
import { User } from '@core/models/user/user';
import { AuthService } from '@core/state/auth/auth.service';
import { SessionService } from '@core/state/session/session.service';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { ElementsModule } from '@shared/elements/elements.module';

@Component({
    selector: 'pay-company-selector',
    templateUrl: './company-selector.component.html',
    styleUrls: [
      './company-selector.component.scss'
    ],
    imports: [
        CommonModule,
        AvatarComponent,
        ElementsModule
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      class: 'c-company-selector'
    }
})
export class CompanySelectorComponent implements OnInit, OnDestroy {

    public readonly ACCOUNT_ROLE: typeof AccountRole = AccountRole;
    public isBusy: boolean;

    public user: User;
    public company: Company;
    public companies: Company[];
    public isAdmin: boolean;
    public isManager: boolean;

    @Output() companyChangeCompleted: EventEmitter<{ success }> = new EventEmitter();

    private destroyed$: Subject<void> = new Subject();

    constructor(private sessionService: SessionService,
                private authService: AuthService,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {

        combineLatest([
            this.sessionService.getCompany(),
            this.sessionService.getUser()
        ])
        .pipe(takeUntil(this.destroyed$))
        .subscribe(([company, user]: [Company, User]) => {
            this.user = user;
            this.company = company;
            this.companies = user?.companies;
            this.isAdmin = company?.role === AccountRole.ADMIN;
            this.isManager = company?.role === AccountRole.MANAGER;
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    changeCompany(company: Company) {
        this.isBusy = true;
        this.cdr.detectChanges();

        this.authService.loginCompany(company.id, true)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
                this.isBusy = false;
                this.cdr.markForCheck();

                this.companyChangeCompleted.next({ success: true });
            }, () => {
                this.isBusy = false;
                this.cdr.markForCheck();

                this.companyChangeCompleted.next({ success: false });
            });
        
    }
}
